export default "__VITE_ASSET__FLco98XH__";